import PulseLoader from "react-spinners/PulseLoader";

export default function Loader() {
  return (
    <div className="text-center">
      <PulseLoader color="white" />
    </div>
  );
}
